module.exports = __webpack_public_path__ + "static/img/2.62c39bf6.jpg";